import { useQueryStates, parseAsInteger } from 'nuqs'

export const useRulesPaginationQueryState = () => {
  return useQueryStates(
    {
      pageIndex: parseAsInteger.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
    },
    { urlKeys: { pageIndex: 'page', pageSize: 'page-size' } }
  )
}
